import DataRoomNdas from './DataRoomNdas.component';

export default DataRoomNdas;